import { ILmsProfileModel } from 'models/lmsProfile.model'
import { ICourseModel } from './course.model'
import { ISigner } from './signer.model'
import { IAreaModel } from './area.model'

export interface ICourseCertificate {
  id?: number
  courseId?: number
  name: string
  lmsProfiles?: ILmsProfileModel[]
}

export interface ICertificate {
  id?: number
  logoUrl?: string
  logo?: any
  name: string
  title: any
  description: string
  certificateType: number
  active: boolean
  createdAt: string

  certificateCourseAttributes: ICourseCertificate[]
  signersAttributes: ISigner[]
}

export interface IMyCertificate {
  id?: number
  createdAt: string
  name: string
  certificate: ICertificate
  courseId?: number | null
  course?: ICourseModel
}

export interface CertificateUser {
  id: number
  identifier: string
  roleId: number | null
  fullName: string
  position: string
  avatar: string
  name: string
  lastname: string
  email: string
  supervisors: any[]
  area: IAreaModel
  lmsProfiles: ILmsProfileModel[]
}

interface ITemplate {
  html: string
  bgImage: string
}

export interface ICourseCertificateUser {
  name: string
  user: CertificateUser
  createdAt: string
  certificate: ICertificate
  courseId: number | null
  finishedAt: string
  template: ITemplate
}

export const initialCourseCertificate: ICourseCertificate = {
  name: '',
}

export const initialCertificate: ICertificate = {
  logo: null,
  name: '',
  title: '',
  description: '',
  certificateType: 0,
  active: true,
  createdAt: '',
  certificateCourseAttributes: [],
  signersAttributes: [],
}

export const initialMyCertificate: IMyCertificate = {
  createdAt: '',
  name: '',
  certificate: initialCertificate,
}
